import type { SecondaryUser } from '../../checkpoint/secondary-users';
import type { ClientUserType } from '../../checkpoint/client-handler';

/** brain_memberships record attached to the authenticated session. */
export interface BrainMember {
    reference_num: string;
    user_id: number | string;
    username?: string;
    email?: string;
    parse_alloc?: string;
    membership?: number;
    [key: string]: unknown;
}

/** Primary (Delight Auth) user returned from SSO ticket exchange. */
export interface PrimaryCheckpointUser {
    id: number;
    email: string;
    username?: string;
    [key: string]: unknown;
}

/** The authenticated user is either a primary member or one of their secondary users. */
export type CheckpointAuthUser = SecondaryUser | PrimaryCheckpointUser;

/**
 * Which kind of Checkpoint session is active. Mirrors the SDK's ClientUserType
 * ('normal' primary member vs 'secondary' tenant user) and types
 * `app.window.userType` in {@link AppWindow}.
 */
export type CheckpointUserType = ClientUserType;

/** Narrow a CheckpointAuthUser to a secondary user (carries super_user_id). */
export function isSecondaryCheckpointUser(user: CheckpointAuthUser): user is SecondaryUser {
    return 'super_user_id' in user && typeof user.super_user_id === 'number';
}
